/**
 * Derives the navigable legs of a trip offer for trips/seat-map and
 * carts/{id}/seats requests.
 *
 * Direct trip (offer.legs absent or with 1 item): a single leg using the
 * offer's own busToken, with kind = the trip direction ('outbound'/'return').
 *
 * Connection (offer.legs.length > 1): one entry per leg, using
 * leg.legBusToken instead of the offer's busToken. kind is always
 * 'connectionLeg' for every leg - direction still travels separately since
 * connectionLeg alone doesn't say which way, and the backend needs it to
 * materialize the leg on the right side.
 */
export function legsFromOffer(offer, direction, selectedPriceId) {
	const legs = offer.legs && offer.legs.length > 1 ? offer.legs : null

	if (!legs) {
		return [
			{
				busToken: offer.busToken,
				legIndex: 0,
				// ordem = legIndex: chave usada pra agrupar as poltronas por
				// trecho (groupTrips) e localizar a poltrona selecionada de um
				// trecho especifico (getDeselectParams).
				ordem: 0,
				kind: direction,
				direction,
				selectedPriceId: selectedPriceId || 0,
				withInsurance: false,
				...legFields(offer, offer)
			}
		]
	}

	// legBusToken doesn't carry the price modality id the way the offer's own
	// busToken does, so it has to be sent explicitly - always the REAL
	// (cash) price, the one the legado requires for CreateOrder.
	const connectionPriceId = selectedPriceId || realSelectedPriceId(offer)

	return legs.map((leg, legIndex) => ({
		busToken: leg.legBusToken || offer.busToken,
		legIndex,
		ordem: legIndex,
		kind: 'connectionLeg',
		direction,
		selectedPriceId: connectionPriceId,
		withInsurance: false,
		...legFields(offer, leg)
	}))
}

function legFields(offer, source) {
	return {
		busClass: source.serviceClassLabel,
		serviceClassLabel: source.serviceClassLabel,
		carrier: source.carrier,
		enterprise: source.carrier && source.carrier.tradeName,
		departure: source.departure,
		arrival: source.arrival,
		// String de exibicao (nao o objeto TripPlace inteiro) - o mesmo trecho
		// e espalhado em cima do seat selecionado (bus-seat-selection.component)
		// e origin/destination viram originCity/destinationCity renderizados
		// direto na tela.
		origin: source.origin && source.origin.displayLabel,
		destination: source.destination && source.destination.displayLabel,
		originId: source.origin && source.origin.id,
		destinationId: source.destination && source.destination.id,
		classCode: offer.classCode,
		scheduleKey: offer.scheduleKey,
		raceDate: offer.raceDate,
		provider: offer.provider,
		group: offer.group,
		service: offer.service
	}
}

/**
 * The offer's REAL (cash) price modality id, among the N modalities
 * (real/pointsAndMoney/pointsOnly) - the one that composes fare + fees and
 * that the legado requires (SelectedPriceId > 0) for CreateOrder.
 */
export function realSelectedPriceId(offer) {
	const realOption =
		offer.paymentOptions && offer.paymentOptions.find(option => option.type === 'real')

	return (realOption && realOption.selectedPriceId) || 0
}
